import { createElement, memo, useCallback, useState, useEffect, useRef } from '@max/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import ScrollView from '@hfe/max-scrollview';
import Text from '@hfe/max-text';
import { getPlatformType } from '@nibfe/mkt-env-api';
import { isAndroid, getImage, getParamsFromUrl } from '../../../utils/utils';
import { photos } from '../../../res/constants';
import TextInput from '@hfe/max-textinput';
import './SearchArea.scss';
import '../CitySelection.scss';
import { getAreaSuggest } from '../../../api/AreaSuggest';
import SuggestAreaItem from '../SuggestAreaItem/SuggestAreaItem';
const isMRN = false;
import LoadingView from '@max/leez-loading-view';
import { DianpingPlatform } from '../../../constants';
function SearchArea(p) {
    var _a;
    const [searchValue, setSearchValue] = useState('');
    const { utm_medium, version_name } = getParamsFromUrl();
    const { city, userInfo } = (_a = p.allStates) !== null && _a !== void 0 ? _a : {};
    const [isLoading, setIsLoading] = useState(false);
    const mountedRef = useRef(true);
    const [suggestAreaList, setSuggestAreaList] = useState([]);
    const emitCloseEventCallback = useCallback(() => {
        p.emitCloseEvent();
    }, []);
    useEffect(() => {
        mountedRef.current = true;
        setIsLoading(true);
        const platformType = getPlatformType();
        const isDianping = DianpingPlatform.includes(platformType);
        const channel = isDianping ? 'dianping' : 'meituan';
        const source = isDianping ? 'dp' : 'mt';
        const args = {
            keyword: searchValue,
            ci: city === null || city === void 0 ? void 0 : city.value,
            uuid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid,
            userid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId,
            token: userInfo === null || userInfo === void 0 ? void 0 : userInfo.token,
            utm_medium,
            version_name,
            channel,
            source
        };
        // 点评侧需要添加utm_campaign参数
        if (isDianping) {
            args.utm_campaign = 'ADianpingBnullC0E0';
        }
        getAreaSuggest(args, res => {
            if (!mountedRef.current)
                return;
            setIsLoading(false);
            setSuggestAreaList(res.data.data);
        }, error => {
            if (!mountedRef.current)
                return;
            setIsLoading(false);
            console.log('error');
        });
        p.emitSearchValueChange(searchValue);
        return () => {
            mountedRef.current = false;
        };
    }, [searchValue, city, userInfo]);
    const textinputStyle = isAndroid && isMRN ? {
        paddingBottom: '9rpx',
        paddingTop: '8rpx'
    } : {};
    return (
    // <View className="search-area-fixed-container">
    <>
      <View className="search-area-container">
        <Image className="search-area-close" source={getImage(photos.CLOSE_ICON)} onClick={emitCloseEventCallback} style={{
        pointerEvents: 'auto'
    }}/>
        <View className="search-area-input-container">
          <Image className="search-area-search-icon" source={getImage(photos.SEARCH_ICON)}/>
          <TextInput className="search-area-input" style={textinputStyle} placeholderColor="#999999" placeholder="城市/行政区/景点" onChangeText={value => setSearchValue(value)}/>
        </View>
      </View>
      <View className="city-selection-divider"/>
      <LoadingView x-if={isLoading} className="search-area-suggest-container"/>
      <ScrollView x-if={searchValue !== '' && suggestAreaList.length > 0 && !isLoading} className="search-area-suggest-container" style={{
        zIndex: 999,
        height: '100%',
        flex: 1
    }}>
        {suggestAreaList.map((item, index) => {
        item.index = index;
        return <View key={`${item.cityId}-${index}`}>
              <SuggestAreaItem areaSuggest={item} dispatchEvent={p.dispatchEvent}/>
              <View className="city-selection-divider"/>
            </View>;
    })}
        <View className="bottom-box"></View>
      </ScrollView>
      <View x-if={searchValue !== '' && suggestAreaList.length === 0 && !isLoading} className="search-area-not-found" style={{
        zIndex: 999,
        height: '100%',
        flex: 1
    }}>
        <Image className="search-area-not-found-image" source={getImage(photos.AREA_NOT_FOUND)}/>
        <View className="search-area-not-found-text-container">
          <Text className="search-area-not-found-text-normal">未找到相关 </Text>
          <Text className="search-area-not-found-text-blue">城市/行政区/地名/酒店名</Text>
        </View>
        <Text className="search-area-not-found-text-bottom">请稍后重试</Text>
      </View>
    
    </>);
}
export default memo(SearchArea);
